import React from "react";
import "./css/modal.css";

function Modal({ item }) {


    const session = JSON.parse(localStorage.getItem("session"));

    const handleDownload = async () => {
        if (!item?.download?.url) return;

        try {
            const response = await fetch(item.download.url, {
                method: "GET",
                headers: {
                    Authorization: "Bearer " + session.password
                }
            });

            if (!response.ok) {
                throw new Error("Download fehlgeschlagen");
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = item.download.name || "download.pdf";

            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Download Fehler:", error);
        }
    };


    return (

        <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1">
            <div className="modal-dialog">
                <div className="modal-content">

                    <div className="modal-header">
                        <h1 className="modal-title fs-5">
                            {item?.title}
                        </h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                    </div>

                    <div className="modal-body">

                        <h6>{item?.year}</h6>

                        {item?.description?.map((text, index) => (
                            <p key={index}>{text}</p>
                        ))}

                    </div>

                    <div className="modal-footer">

                        {item?.download && (
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleDownload}
                            >
                                {item.download.name || "Download"}
                            </button>
                        )}

                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-bs-dismiss="modal"
                        >
                            Schließen
                        </button>

                    </div>

                </div>
            </div>
        </div>

    );
}

export default Modal;